module.exports = __webpack_public_path__ + "static/img/智能风险评估_产品截图_image@2x.19c906f6.png";